<template>
  <ul class="grid gap-24">
    <li v-for="entry in CONTENT" :key="entry.key" class="grid gap-8">
      <!-- Films are idle until clicked: a still, and nothing fetched. -->
      <NativeVideo
        v-if="entry.kind === 'video'"
        :id="entry.video.id"
        :sources="sourcesFor(entry.video.name)"
        :poster="entry.video.poster"
        :inline="awake === entry.video.id ? 'loop' : 'poster'"
        :title="i18n(entry.title)"
        @play="handlePlay(entry.video.id)"
      />
      <ArticleTile
        v-else
        :article="entry.article"
        @open="handleOpen(entry.article)"
      />
      <h3 class="raw-heading-4">
        {{ i18n(entry.title) }}
      </h3>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

import NativeVideo from '~/scopes/campaign/components/UI/NativeVideo.vue'
import ArticleTile from '~/scopes/campaign/components/highlights/ArticleTile.vue'
import { useModalState } from '~/scopes/campaign/composables/useModalState'
import { useVideoSources } from '~/scopes/campaign/composables/useVideoSources'
import type { Article } from '~/scopes/campaign/data/articles/data'
import { CONTENT } from '~/scopes/campaign/data/content'

const i18n = useI18n()
const { trackClick } = useTracking()
const { sourcesFor } = useVideoSources()
const { activeCinema, navigateToArticle } = useModalState()

// The one film still looping: whichever this list last opened in cinema. Seeded from the
// URL for a cold deep link, then moved only by this list's own clicks — a
// `watch(activeCinema)` would wake a twin when the impacts rail opens the same id.
const awake = ref<string | null>(activeCinema.value)

function handlePlay(id: string) {
  awake.value = id
  trackClick({ zone: 'content-gallery', name: id, campaign: 'raw-materials' })
}

// A story leaves the panel — its path is the story's own, as everywhere else.
function handleOpen(article: Article) {
  trackClick({
    zone: 'content-gallery',
    name: article.slug,
    campaign: 'raw-materials',
  })
  navigateToArticle(article)
}
</script>
